module.exports = __webpack_public_path__ + "be8d3b7343489e7028ba5ef372fcd9a6.MP3";